// Official report verdict thresholds. Report cards, status labels and any
// prose that calls a value "good / needs improvement / poor" must read this
// map instead of embedding a second numeric threshold in copy.
export const METRIC_THRESHOLDS = Object.freeze({
  lcp: Object.freeze({ good: 2500, poor: 4000, unit: 'ms', target: 2500 }),
  inp: Object.freeze({ good: 200, poor: 500, unit: 'ms', target: 200 }),
  cls: Object.freeze({ good: 0.1, poor: 0.25, unit: '', target: 0.1 }),
  fcp: Object.freeze({ good: 1800, poor: 3000, unit: 'ms', target: 1800 }),
  tbt: Object.freeze({ good: 200, poor: 600, unit: 'ms', target: 200 }),
  ttfb: Object.freeze({ good: 800, poor: 1800, unit: 'ms', target: 800 })
});

export const metricThreshold = (metric) =>
  METRIC_THRESHOLDS[String(metric || '').toLowerCase()] || null;